
import Button from '../../../components/base/Button';

export default function AdvocacySection() {
  const advocacyInitiatives = [
    {
      title: "Policy Development",
      description: "Working with government agencies to develop healthcare policies that benefit both human and animal health.",
      icon: "ri-government-line",
      status: "Active"
    },
    {
      title: "Professional Scope Expansion",
      description: "Advocating for expanded practice privileges for pharmacy and veterinary professionals.",
      icon: "ri-user-settings-line",
      status: "In Progress"
    },
    {
      title: "Regulatory Reform",
      description: "Streamlining regulations to improve collaborative care between healthcare disciplines.",
      icon: "ri-file-list-3-line",
      status: "Planning"
    },
    {
      title: "Public Health Initiatives",
      description: "Promoting One Health approaches in public policy and community health programs.",
      icon: "ri-heart-pulse-line",
      status: "Active"
    }
  ];

  const recentWins = [
    {
      title: "Prescription Authority Expansion",
      date: "January 2025",
      description: "Successfully advocated for expanded prescription authority for pharmacists in three provinces."
    },
    {
      title: "Veterinary Telehealth Approval",
      date: "December 2024",
      description: "Secured regulatory approval for veterinary telehealth services across Canada."
    },
    {
      title: "Collaborative Care Framework",
      date: "November 2024",
      description: "Established new framework for pharmacy-veterinary collaborative care models."
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="ri-megaphone-line text-2xl text-blue-600"></i>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Advocacy & Policy
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Strong representation for policy development, regulatory affairs, and professional advancement in healthcare legislation.
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-8">Current Initiatives</h3>
            <div className="space-y-6">
              {advocacyInitiatives.map((initiative, index) => (
                <div key={index} className="bg-white rounded-lg p-6 hover:shadow-md transition-shadow">
                  <div className="flex items-start">
                    <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                      <i className={`${initiative.icon} text-xl text-blue-600`}></i>
                    </div>
                    <div className="flex-1">
                      <div className="flex items-center justify-between mb-2">
                        <h4 className="text-lg font-semibold text-gray-900">
                          {initiative.title}
                        </h4>
                        <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                          initiative.status === 'Active' ? 'bg-green-100 text-green-800' :
                          initiative.status === 'In Progress' ? 'bg-yellow-100 text-yellow-800' :
                          'bg-gray-100 text-gray-800'
                        }`}>
                          {initiative.status}
                        </span>
                      </div>
                      <p className="text-gray-600">
                        {initiative.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-8">Recent Wins</h3>
            <div className="space-y-6">
              {recentWins.map((win, index) => (
                <div key={index} className="bg-white rounded-lg p-6 border-l-4 border-green-500">
                  <div className="flex items-center justify-between mb-2">
                    <h4 className="text-lg font-semibold text-gray-900">
                      {win.title}
                    </h4>
                    <span className="text-sm text-gray-500">{win.date}</span>
                  </div>
                  <p className="text-gray-600">
                    {win.description}
                  </p>
                </div>
              ))}
            </div>
            
            <div className="mt-8 bg-blue-900 rounded-lg p-6 text-white">
              <h4 className="text-xl font-semibold mb-3">Get Involved</h4>
              <p className="mb-4">
                Join our advocacy efforts and help shape the future of healthcare policy in Canada.
              </p>
              <Button className="bg-white text-blue-900 hover:bg-gray-100">
                Join Advocacy Network
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
